import PropTypes from 'prop-types'
import styled from 'styled-components'
import { components } from 'react-select'

import colors from 'components/utils/colors'
import { InnerComponent } from 'components/utils/innerReactSelectComponents'

const StyledMenuList = styled(InnerComponent).attrs({ Component: components.MenuList })`
  font-family: Exo;
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  letter-spacing: 0.3px;
  padding: 5px 8px 5px 8px;
  color: ${colors.contentSecondaryInactive};
`

const MenuList = (props) => {
  const { optionsTitle } = props.selectProps

  return (
    <components.MenuList {...props}>
      <StyledMenuList {...props}>{optionsTitle}</StyledMenuList>
      {props.children}
    </components.MenuList>
  )
}

MenuList.propTypes = {
  selectProps: PropTypes.object,
  children: PropTypes.node,
}

export default MenuList
